module.exports = __webpack_public_path__ + "img/slotmachine.5d3d3eb9.png";